import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
    }`}>
      <div className="w-full px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
            <div className="bg-gradient-to-br from-amber-400 to-orange-500 rounded-full p-2 w-12 h-12 flex items-center justify-center">
              <i className="ri-store-2-fill text-2xl text-white"></i>
            </div>
            <span className={`text-xl font-bold ${isScrolled ? 'text-gray-800' : 'text-white'}`}>
              Золотое Яблоко
            </span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('rules')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Как получить
            </button>
            <button 
              onClick={() => scrollToSection('game')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Опрос
            </button>
            <button 
              onClick={() => scrollToSection('gift')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Награда
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors cursor-pointer ${
                isScrolled ? 'text-gray-700 hover:text-orange-600' : 'text-white hover:text-orange-300'
              }`}
            >
              Контакты
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`md:hidden text-2xl cursor-pointer ${
              isScrolled ? 'text-gray-800' : 'text-white'
            }`}
          >
            <i className={isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 bg-white rounded-2xl shadow-xl p-4">
            <button 
              onClick={() => scrollToSection('rules')}
              className="block w-full text-left py-3 px-4 text-gray-700 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer"
            >
              Как получить
            </button>
            <button 
              onClick={() => scrollToSection('game')}
              className="block w-full text-left py-3 px-4 text-gray-700 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer"
            >
              Опрос
            </button>
            <button 
              onClick={() => scrollToSection('gift')}
              className="block w-full text-left py-3 px-4 text-gray-700 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer"
            >
              Награда
            </button>
            <button 
              onClick={() => scrollToSection('faq')}
              className="block w-full text-left py-3 px-4 text-gray-700 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer"
            >
              FAQ
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="block w-full text-left py-3 px-4 text-gray-700 hover:bg-orange-50 rounded-lg transition-colors cursor-pointer"
            >
              Контакты
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
